import {Pipe, Sanitizer, SecurityContext} from "@angular/core";

@Pipe({name: 'safeHtml'})
export class SafeHtmlPipe {
  constructor(private sanitizer:Sanitizer){}

  transform(style) {
    return this.sanitizer.sanitize(SecurityContext.HTML, style);
    // return this.sanitizer.bypassSecurityTrustHtml(style);
    // return this.sanitizer.bypassSecurityTrustXxx(style); - see docs
  }
}



// WEBPACK FOOTER //
// ./src/app/core/safe-html.pipe.ts